import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faPinterest,
  faTiktok,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { IconModule } from '@x/common/icon';
import { OperationModule } from '@x/common/operation';
import { ResponsiveModule } from '@x/common/responsive';
import { ContentRenderSharedModule } from '@x/content/render/content-render-shared.module';
import { BrandingModule } from '@x/ecommerce-shop/app/core/shop-ui/components/branding/branding.module';
import { PageLayoutModule } from '@x/ecommerce-shop/app/core/shop-ui/components/layout/page-layout';
import { ShopFooterComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-footer/shop-footer.component';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { IconUiModule } from '../icon-ui/icon-ui.module';
import { CheckoutFooterComponent } from './checkout-footer/checkout-footer.component';
import { FooterBrandingComponent } from './footer-branding/footer-branding.component';
import { FooterContentComponent } from './footer-content/footer-content.component';
import { FooterMenuComponent } from './footer-menus/footer-menu.component';
import { FooterMenusComponent } from './footer-menus/footer-menus.component';
import { FooterPaymentMethodsComponent } from './footer-payment-methods/footer-payment-methods.component';

@NgModule({
  declarations: [
    ShopFooterComponent,
    FooterMenuComponent,
    FooterBrandingComponent,
    FooterMenusComponent,
    FooterContentComponent,
    CheckoutFooterComponent,
    FooterPaymentMethodsComponent,
  ],
  exports: [ShopFooterComponent, CheckoutFooterComponent, FooterContentComponent],
  imports: [
    CommonModule,
    IconModule.forFeature([
      faFacebook,
      faInstagram,
      faLinkedin,
      faPinterest,
      faTiktok,
      faTwitter,
      faYoutube,
    ]),
    ContentRenderSharedModule,
    RouterModule,
    PageLayoutModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    IconUiModule,
    ResponsiveModule,
    MatExpansionModule,
    BrandingModule,
    UtilsModule,
    OperationModule,
  ],
})
export class ShopFooterModule {}
